export default "__VITE_ASSET__BHIdOslO__"